export interface Alert {
  fieldId: string | FieldId.Unknown
  fieldName?: string
  message: string
  productId: string
  productDisplayId: string
  productDisplayIdLabel: string
  productDescription: string
}

export enum FieldId {
  Unknown = -1,
}
